import axios from 'axios'

export const getMyOffices = () => {
  return axios.get('/personnel-management/my-offices')
}

export const getMyOfficesDebug = (debugUserID) => {
  return axios.get('personnel-management/debug/my-offices', { params: { debugUserId: debugUserID } })
}

export const getLoanProductionDataForOffice = async ({ id, period }) => {
  return axios.get(`/leaderboard/ranking-by-office?officeId=${id}&year=${period}`, {
    transformResponse: [
      (res) => {
        const resJson = JSON.parse(res)
        resJson.data.period = period || new Date().getFullYear()
        return resJson
      },
    ],
  })
}

export const getLoanProductionDataForOfficeExport = async ({ id, period }) => {
  return axios.get(`/export/csv/office_production`, {
    params: {
      officeId: id,
      period,
    },
  })
}

export const getLoanProductionPeriods = async () => {
  return axios.get(`/leaderboard/periods`)
}

export const getUserById = ({ id }) => {
  return axios.get(`/personnel-management/user/${id}`)
}

export const saveOfficeDetails = ({ id, officeDetails }) => {
  return axios.put(`/personnel-management/office/${id}`, {
    ...officeDetails,
  })
}

export const postUser = ({ userDetails }) => {
  return axios.post(`/personnel-management/user`, {
    ...userDetails,
  })
}

export const putUser = ({ userId, userDetails }) => {
  return axios.put(`/personnel-management/user/${userId}`, {
    ...userDetails,
  })
}

export const accessibleTerminateUser = ({
  user,
  userId,
  newSecondaryEmail,
  newWebAdminId,
  newLicensingAdminId,
  officeId,
}) => {
  return axios.post(`/personnel-management/user/accessible-termination/${userId}`, {
    ...user,
    newSecondaryEmail,
    newWebAdminId,
    newLicensingAdminId,
    officeId,
  })
}

export const deactivateUser = ({ userId, newWebAdminId, newLicensingAdminId, officeId }) => {
  return axios.post(`/personnel-management/user/deactivate/${userId}`, { newWebAdminId, newLicensingAdminId, officeId })
}

export const requestDeactivationForUser = ({
  userId,
  mottoForwardEmail,
  loanToTransfer,
  terminationReasonLoPhaseTwo,
  terminationReasonLoPhaseTwoOther,
  newWebAdminId,
  newLicensingAdminId,
  officeId,
}) => {
  if (mottoForwardEmail) {
    return axios.post(`/personnel-management/user/accessible-termination/request/${userId}`, {
      newSecondaryEmail: mottoForwardEmail,
      loanToTransfer,
      terminationReasonLoPhaseTwo,
      terminationReasonLoPhaseTwoOther,
      newWebAdminId,
      newLicensingAdminId,
      officeId,
    })
  }

  return axios.post(`/personnel-management/user/deactivate/request/${userId}`, {
    loanToTransfer,
    terminationReasonLoPhaseTwo,
    terminationReasonLoPhaseTwoOther,
    newWebAdminId,
    newLicensingAdminId,
    officeId,
  })
}

export const getEmailOptions = ({ userDetails }) => {
  return axios.post('/user/email/options', { ...userDetails })
}

export const getMottoRoles = () => {
  return axios.get('/account')
}

export const getGroups = () => {
  return axios.get('/personnel-management/user/groups')
}

export const getUserDropdownOptions = ({ options = ['timezone'] } = {}) => {
  const optionsUri = options.reduce((acc, curr) => acc + `&options[]=${curr}`, '')
  return axios.get('/system/dropdown-options?' + optionsUri)
}

export const updateProfilePhoto = ({ formData, userId }) => {
  return axios.post(`/personnel-management/update-profile-picture-user/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const getMyIntegrationStatus = () => {
  return axios.get('/personnel-management/integrations')
}

export const getMyAssignedProspects = () => {
  return axios.get('/prospect/my-assigned-prospects')
}

export const declineProspect = ({ prospectId, reasonForDecline, reasonForDeclineOther }) => {
  return axios.put(`/prospect/decline/${prospectId}`, { reasonForDecline, reasonForDeclineOther })
}

export const getProspectAssignedById = (prospectAssignedId) => {
  return axios.get(`/prospect/assigned/${prospectAssignedId}`)
}
